import type { FaireProductEntity } from "../../entity_types/product";

export const p_2ut6hws8cn: FaireProductEntity = {
  token: "p_2ut6hws8cn",
  type: "product",
  name: "Mama Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/fd0846c5f26249552cde7d9b9478028c6d8f7b16025106a050956ca38f252caa.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6d0a19a6905c49bd7478cd3060aeecb493b79ecc898c413e9a8e786eab721209.jpeg",
    "https://cdn.faire.com/fastly/c2d402d721513c02b35d0f0e5aefa89fe418f31ba1c01242d72d5ea11753f04e.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/26c9eaa4bc5fce3e31554c57873ee90087f1c4327f406684165a54d220ea8601.jpeg",
    "https://cdn.faire.com/fastly/215902a91fa3b7172e84f7e5da69f3e4b956760d4bc28bcd82403c2d9a1c8683.jpeg",
    "https://cdn.faire.com/fastly/7bdedab50fef9b947a618f666e16f76166b950d4974c233d10a761d08fc26144.jpeg",
    "https://cdn.faire.com/fastly/e9fc495e50dffa53b324ee026dd79b3ab997fa5bc3ceb133c763d4e78d2f8d5e.jpeg"
  ],
  priceDollars: 6.75,
  description: "If you've become your friend group's legal guardian... these socks are for you 😉\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:28:13.926Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
